export const GlobalFilterModalHashId = 'global-filter';
